module.exports = __webpack_public_path__ + "static/media/address.3811f256.svg";